import { createContext, useContext } from 'react'
import type { RealtimeEventKey, RealtimePayload, SubscribeCommand } from './contract'
import type { RealtimeStatus } from './transport'

export interface RealtimeContextValue {
  status: RealtimeStatus
  subscribe(key: RealtimeEventKey, handler: (payload: RealtimePayload) => void): () => void
  /** Entra numa room de recurso (`subscribe` com ack); devolve a função de saída. */
  joinRoom(command: SubscribeCommand): () => void
}

export const RealtimeContext = createContext<RealtimeContextValue | null>(null)

export function useRealtime(): RealtimeContextValue {
  const context = useContext(RealtimeContext)
  if (!context) throw new Error('useRealtime precisa estar dentro de <RealtimeProvider>.')
  return context
}
